
import React from 'react';

const ServicesHero: React.FC = () => {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.85), rgba(248, 250, 252, 0.9)), url('https://readdy.ai/api/search-image?query=Modern%20bioinformatics%20research%20laboratory%20with%20advanced%20genomic%20sequencing%20equipment%2C%20computer%20workstations%20displaying%20data%20analysis%20software%2C%20clean%20professional%20scientific%20environment%20with%20natural%20lighting%20and%20glass%20surfaces&width=1920&height=800&seq=services-hero&orientation=landscape')`
      }}
    >
      {/* 装饰性元素 */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-20 h-20 bg-blue-200/30 rounded-full blur-xl"></div>
        <div className="absolute top-32 right-20 w-32 h-32 bg-purple-200/30 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-indigo-200/30 rounded-full blur-xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl font-bold mb-6 text-gray-900">
          <strong className="text-blue-600">定制化</strong>科研服务
        </h1>
        <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-700">
          从数据分析到论文发表，提供全方位的<strong className="text-gray-900">科研支持服务</strong>
        </p>
        
        {/* 服务特色标签 */}
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <span className="bg-blue-100/80 text-blue-800 px-4 py-2 rounded-full text-sm font-medium backdrop-blur-sm">
            专业团队
          </span>
          <span className="bg-green-100/80 text-green-800 px-4 py-2 rounded-full text-sm font-medium backdrop-blur-sm">
            快速交付
          </span>
          <span className="bg-purple-100/80 text-purple-800 px-4 py-2 rounded-full text-sm font-medium backdrop-blur-sm">
            质量保证
          </span>
          <span className="bg-orange-100/80 text-orange-800 px-4 py-2 rounded-full text-sm font-medium backdrop-blur-sm">
            全程指导
          </span>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
